<template>
    <div style="display:grid; gap:15px">
        <h3>Seguimiento de tramitadores</h3>
        <div style="display:flex; justify-content:space-between; gap:15px">
            <div style="display:flex; justify-content:center; gap:5px">
                <input type="date" class="form-control form-control-sm" v-model="fecha_inicio">
                <input type="date" class="form-control form-control-sm" v-model="fecha_fin">
            </div>
            <select v-model="usuario_seleccionado" class="form-control form-control-sm">
                <option value="">Seleccione usuario</option>
                <option v-for="usuario in usuarios" :key="usuario.idusuario" :value="usuario.idusuario">{{ usuario.nombre }}</option>
            </select>
            <input v-model="filtro_servicio" placeholder="Filtrar servicio" type="text" class="form-control form-control-sm">
            <select v-model="tipo_seleccionado" class="form-control form-control-sm">
                <option value="">Seleccione tipo</option>
                <option v-for="tipo in tipos" :key="tipo" :value="tipo">{{ tipo }}</option>
            </select>
            <input v-model="filtro_informacion" placeholder="Filtrar información" type="text" class="form-control form-control-sm">
            <div style="display:flex; gap:5px">
                <button class="btn btn-sm btn-primary" @click="obtenerListado">Listado</button>
                <button class="btn btn-sm btn-primary" @click="descargarExcel">Excel</button>
            </div>
        </div>
        <tabla-datos :botoncrear="1" @quieroDatos="obtenerListado($event);" :total="total" :columnas="columnas" 
        :datos="expedientes" :filtros="false">
        </tabla-datos>
    </div>
</template>
<script>
import TablaDatos from '../TablaDatos.vue';
import { PwgsApi } from '../../services/PwgsApi';
export default {
    props:[],
    components:{
        "tabla-datos": TablaDatos,
    },
    data(){
        return{
            url_global: localStorage.getItem('direccion'),
            expedientes: [],
            total:0,
            filtro_servicio: '',
            filtro_informacion: '',
            tipo_seleccionado: '',
            tipos: [],
            usuario_seleccionado: '',
            usuarios:[],
            fecha_inicio: '',
            fecha_fin: '',
            columnas: [
                {
                    header: 'Fecha',
                    field: 'fecha',
                },
                {
                    header: 'Usuario',
                    field: 'usuario',
                },
                {
                    header: 'Servicio',
                    field: 'codigo_servicio',
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'id_servicio',
                            accion: (id) => {
                                let direccion = localStorage.getItem('direccion');
                                if(direccion == 'null.pwgs.app') direccion = 'pwgs.raul.pwgs5.interno.apuyen.app';
                                let aux = "https://" + direccion + "/seguimiento.php?servicio="+id;
                                window.open(aux,'_blank');                                
                            }
                        }
                    ]
                },
                {
                    header: 'Tipo',
                    field: 'tipo',
                },
                {
                    header: 'Información',
                    field: 'informacion_tramitadores',
                },
                {
                    header: 'Tiempo inactivo desde la última acción',
                    field: 'tiempo_inactivo',
                }
            ]
        }
    },
    methods:{
        async descargarExcel() {
            const event = {};
            if(!event.tipo_seguimiento) event.tipo_seguimiento = 'tramitadores';
            const api = new PwgsApi();
            if(!event.rows){
                event.rows = 3000;
                event.page = 0;
            }
            event.usuarios = this.usuario_seleccionado;
            event.servicio = this.filtro_servicio;
            event.informacion = this.filtro_informacion;
            event.tipo = this.tipo_seleccionado;
            event.fecha = this.formatearFecha(this.fecha_inicio);
            event.fecha_fin = this.formatearFecha(this.fecha_fin);
            const resp = await api.post('seguimiento',event);
            var exp = resp.datos;
            this.total = resp.n_total_registros;

            if(this.url_global == 'null.pwgs.app'){
                this.url_global = 'pwgs.raul.pwgs5.interno.apuyen.app';
            }
            const url = "https://" + this.url_global + "/impreso_seguimiento.php";

            const datos = {
                seguimientos: exp,
                fecha: this.fecha_inicio,          // ajusta a tus variables reales
                fecha_fin: this.fecha_fin,
                informacion: this.filtro_informacion
            };

            // Abrimos la ventana primero (evita bloqueos de pop-up en algunos navegadores)
            window.open('', 'SeguimientoExcel', 'width=800,height=600');

            // Creamos un form oculto para enviar el POST a esa ventana
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;
            form.target = 'SeguimientoExcel';

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'datos';
            input.value = JSON.stringify(datos);
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },
        cargarDatos(){
            this.cargarUsuarios();
            this.cargarTipos();
            this.fecha_inicio = this.diaActual();
            this.fecha_fin = this.diaActual();
            this.obtenerListado({tipo_seguimiento: 'tramitadores'});
        },
        async obtenerListado(event){
            if(!event) event = {};
            if(!event.tipo_seguimiento) event.tipo_seguimiento = 'tramitadores';
            const api = new PwgsApi();
            if(!event.rows){
                event.rows = 15;
                event.page = 0;
            }
            event.usuarios = this.usuario_seleccionado;
            event.servicio = this.filtro_servicio;
            event.informacion = this.filtro_informacion;
            event.tipo = this.tipo_seleccionado;
            event.fecha = this.formatearFecha(this.fecha_inicio);
            event.fecha_fin = this.formatearFecha(this.fecha_fin);
            const resp = await api.post('seguimiento',event);
            this.expedientes = resp.datos;
            this.total = resp.n_total_registros;
        },
        async cargarTipos() {
            const api = new PwgsApi();
            const resp = await api.get('/tipos-seguimiento'); 
            this.tipos = resp.datos; 
        },
        async cargarUsuarios() {
            const api = new PwgsApi();
            const resp = await api.post('/usuarios-seguimiento',{tipo:'tramitadores'});
            this.usuarios = resp.datos;
        },
        diaActual() {
          const hoy = new Date();
          return hoy.toISOString().split('T')[0];  
        },
        formatearFecha(fecha) {
            const partes = fecha.split('-');
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
    },
    mounted(){
        this.cargarDatos();
    }
}

</script>
